const detachPaymentMethod = () => {};

export default detachPaymentMethod;
